(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  // Menú de escritorio: el grupo bajo el ratón (o con el foco) enseña sus enlaces a la derecha.
  document.querySelectorAll('[data-mega]').forEach((panel) => {
    const grupos = panel.querySelectorAll('.nav__g[data-grupo]');
    const subs = panel.querySelectorAll('.nav__sub');
    const activar = (g) => {
      grupos.forEach((x) => x.classList.toggle('is-activo', x === g));
      subs.forEach((sub) => { sub.hidden = sub.dataset.sub !== g.dataset.grupo; });
    };
    grupos.forEach((g) => {
      g.addEventListener('mouseenter', () => activar(g));
      g.addEventListener('focus', () => activar(g));
    });
  });

  // La cabecera fija tapa a cualquier cosa que se pegue debajo (la galería de la ficha, por
  // ejemplo). Publica su alto real en --cab-alto para que los demás se aparten de ella.
  (() => {
    const cab = document.querySelector('.cab--sticky');
    if (!cab) return;
    // Se mide SOLO la cabecera: el aviso de arriba se va con el scroll, así que contarlo
    // dejaba el margen de más y lo que se pegaba debajo caía en el sitio equivocado.
    const medir = () => document.documentElement.style.setProperty('--cab-alto', Math.round(cab.getBoundingClientRect().height) + 'px');
    medir();
    window.addEventListener('resize', medir);
    if ('ResizeObserver' in window) new ResizeObserver(medir).observe(cab);

    // Móvil: al bajar se recoge el buscador; al subir, o cerca del principio, se despliega.
    // Nunca mientras se escribe en él ni con el cajón del menú abierto.
    const movil = window.matchMedia('(max-width: 899px)');
    let ultimo = window.scrollY, pendiente = false;
    const paso = () => {
      pendiente = false;
      const y = window.scrollY;
      if (!movil.matches) { cab.classList.remove('cab--compacta'); ultimo = y; return; }
      const escribiendo = document.activeElement && cab.contains(document.activeElement) && document.activeElement.tagName === 'INPUT';
      const cajon = cab.querySelector('[data-cajon]');
      if (escribiendo || (cajon && cajon.open)) { ultimo = y; return; }
      if (y > ultimo + 6 && y > 160) cab.classList.add('cab--compacta');
      else if (y < ultimo - 6 || y < 80) cab.classList.remove('cab--compacta');
      ultimo = y;
    };
    window.addEventListener('scroll', () => { if (!pendiente) { pendiente = true; requestAnimationFrame(paso); } }, { passive: true });
  })();

  // Cajón móvil: se monta con los enlaces del menú de escritorio (una sola copia en el HTML). Se hace en un rato
  // libre tras cargar, o al tocar ☰ si alguien llega antes. Abre ya desplegada la rama de la página en la que está.
  const montarCajon = (d) => {
    const ul = d.querySelector('.cajon__l1'), nav = document.querySelector('.nav .nav__l1');
    if (!ul || !nav || d.dataset.montado) return;
    d.dataset.montado = '1';
    const esc = (x) => String(x).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
    const ver = (t) => esc((ul.dataset.ver || '%T%').replace('%T%', t));
    const aqui = location.pathname.replace(/\/$/, '');
    const es = (u) => { try { return new URL(u, location.href).pathname.replace(/\/$/, '') === aqui; } catch (e) { return false; } };
    const cur = (u) => (es(u) ? ' aria-current="page"' : '');
    const ab = '<i class="icono icono--abajo" aria-hidden="true"></i>';
    let html = '';
    nav.querySelectorAll(':scope > li').forEach((li) => {
      const a = li.querySelector(':scope > .nav__a'); if (!a) return;
      const t = a.textContent.trim(), u = a.getAttribute('href');
      const grupos = li.querySelectorAll('.nav__grupos .nav__g');
      if (!grupos.length) { html += '<li><a class="cajon__enlace" href="' + esc(u) + '"' + cur(u) + '>' + esc(t) + '</a></li>'; return; }
      let abierto = false, l2 = '<li><a class="cajon__ver" href="' + esc(u) + '">' + ver(t) + '</a></li>';
      grupos.forEach((g) => {
        const gt = (g.querySelector('span') || g).textContent.trim(), gu = g.getAttribute('href');
        const sub = g.dataset.grupo ? li.querySelector('.nav__sub[data-sub="' + g.dataset.grupo + '"] .nav__l3') : null;
        if (!sub) { if (es(gu)) abierto = true; l2 += '<li><a href="' + esc(gu) + '"' + cur(gu) + '>' + esc(gt) + '</a></li>'; return; }
        let ab2 = false, l3 = '<li><a class="cajon__ver" href="' + esc(gu) + '">' + ver(gt) + '</a></li>';
        sub.querySelectorAll('a').forEach((x) => { const xu = x.getAttribute('href'); if (es(xu)) ab2 = true; l3 += '<li><a href="' + esc(xu) + '"' + cur(xu) + '>' + esc(x.textContent.trim()) + '</a></li>'; });
        if (ab2) abierto = true;
        l2 += '<li><details class="cajon__det cajon__det--2"' + (ab2 ? ' open' : '') + '><summary><span>' + esc(gt) + '</span>' + ab + '</summary><ul class="cajon__l3">' + l3 + '</ul></details></li>';
      });
      html += '<li><details class="cajon__det"' + (abierto ? ' open' : '') + '><summary><span>' + esc(t) + '</span>' + ab + '</summary><ul class="cajon__l2">' + l2 + '</ul></details></li>';
    });
    ul.innerHTML = html;
  };
  document.querySelectorAll('[data-cajon]').forEach((d) => {
    const ya = () => montarCajon(d);
    d.querySelector('summary').addEventListener('pointerdown', ya, { once: true });
    d.addEventListener('toggle', ya);
    if ('requestIdleCallback' in window) requestIdleCallback(ya, { timeout: 4000 }); else setTimeout(ya, 2500);
  });

  // Cajón móvil: cerrar con el fondo, la X o Escape
  document.querySelectorAll('[data-cajon]').forEach((d) => {
    d.querySelectorAll('[data-cajon-cerrar]').forEach((b) => b.addEventListener('click', () => { d.open = false; }));
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') d.open = false; });
  });
  // Buscador en móvil: el icono despliega el formulario
  document.querySelectorAll('[data-buscar-movil]').forEach((b) => b.addEventListener('click', () => {
    const f = document.querySelector('[data-buscador]'); if (!f) return;
    f.classList.toggle('is-open'); if (f.classList.contains('is-open')) f.querySelector('input[type=search]').focus();
  }));
  // Sugerencias de búsqueda: pide la sección predictive-search y la pinta debajo
  document.querySelectorAll('[data-buscador]').forEach((form) => {
    const input = form.querySelector('input[type=search]'); const box = form.querySelector('[data-sugerencias]');
    if (!input || !box) return;
    // En un móvil con datos, escribir «lavadora» lanzaba siete peticiones que no se cancelaban:
    // competían por la conexión y las respuestas llegaban tarde y desordenadas (24/09). Ahora sólo
    // hay una viva, lo ya buscado se guarda, y con la red lenta se espera un poco más entre letras.
    const cache = new Map();
    let t, cancelar = null;
    const red = navigator.connection && navigator.connection.effectiveType || '';
    const espera = /2g/.test(red) ? 450 : red === '3g' ? 320 : 220;
    const cerrar = () => { box.hidden = true; input.setAttribute('aria-expanded', 'false'); };
    const pintar = (html) => {
      if (!html) { cerrar(); return; }
      box.innerHTML = html; box.hidden = false; input.setAttribute('aria-expanded', 'true');
    };
    input.addEventListener('input', () => {
      clearTimeout(t); const q = input.value.trim();
      if (q.length < 2) { if (cancelar) cancelar.abort(); cerrar(); return; }
      if (cache.has(q)) { pintar(cache.get(q)); return; }   // ya buscado (borrar una letra, repetir)
      t = setTimeout(async () => {
        if (cancelar) cancelar.abort();                      // la anterior ya no interesa
        cancelar = new AbortController();
        try {
          const r = await fetch(`${window.Shopify?.routes?.root || '/'}search/suggest?q=${encodeURIComponent(q)}&resources[type]=product,collection,page&resources[limit]=6&section_id=predictive-search`, { signal: cancelar.signal });
          if (!r.ok) return;
          const html = await r.text(); const doc = new DOMParser().parseFromString(html, 'text/html');
          const n = doc.querySelector('[data-predictive]');
          const trozo = n && n.innerHTML.trim() ? n.innerHTML : '';
          if (cache.size > 30) cache.clear();
          cache.set(q, trozo);
          if (input.value.trim() === q) pintar(trozo);       // si ya escribió más, esta respuesta sobra
        } catch (e) { if (e.name !== 'AbortError') cerrar(); }
      }, espera);
    });
    form.addEventListener('submit', () => { clearTimeout(t); if (cancelar) cancelar.abort(); });
    document.addEventListener('click', (e) => { if (!form.contains(e.target)) cerrar(); });
    input.addEventListener('keydown', (e) => { if (e.key === 'Escape') { clearTimeout(t); if (cancelar) cancelar.abort(); cerrar(); } });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-hslider]').forEach((root) => {
    const slides = [...root.querySelectorAll('[data-hslide]')];
    if (slides.length < 2) return;
    const puntos = [...root.querySelectorAll('[data-ir]')];
    const dur = parseInt(root.dataset.autoplay || '0', 10);
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    // «parado» es la pausa que pide la persona con el botón y manda sobre todo lo demás;
    // «quieto» es la pausa de cortesía mientras el ratón o el foco están encima.
    let i = 0, timer = 0, quieto = false, parado = false;
    const foco = (s, on) => s.querySelectorAll('a:not(.hslide__todo), button').forEach((a) => { a.tabIndex = on ? 0 : -1; });
    slides.forEach((s, k) => foco(s, k === 0));
    const programar = () => {
      clearTimeout(timer);
      if (!dur || reduce || quieto || parado || document.visibilityState !== 'visible') return;
      timer = setTimeout(() => ir(i + 1), dur);
    };
    // Las inactivas están en display:none para que el navegador no baje sus fotos. Para que el
    // fundido siga viéndose, la que sale se queda pintada («is-saliendo») mientras dura la transición.
    const ir = (n, porMano) => {
      const antes = i;
      i = (n + slides.length) % slides.length;
      if (antes === i) return;
      const saliendo = slides[antes];
      const entrando = slides[i];
      saliendo.classList.add('is-saliendo');
      entrando.classList.add('is-entrando');
      slides.forEach((s, k) => {
        const on = k === i;
        if (on) s.classList.remove('is-saliendo');
        s.setAttribute('aria-hidden', on ? 'false' : 'true');
        foco(s, on);
      });
      requestAnimationFrame(() => requestAnimationFrame(() => {
        slides.forEach((s, k) => s.classList.toggle('is-active', k === i));
      }));
      setTimeout(() => { saliendo.classList.remove('is-saliendo'); entrando.classList.remove('is-entrando'); }, 900);
      puntos.forEach((p, k) => { if (k === i) p.setAttribute('aria-current', 'true'); else p.removeAttribute('aria-current'); });
      // Si el cambio lo pidió una persona, el foco va al contenido nuevo; si pasa solo, no se toca.
      if (porMano) slides[i].querySelector('a, button')?.focus({ preventScroll: true });
      programar();
    };
    root.querySelector('[data-next]')?.addEventListener('click', () => ir(i + 1, true));
    root.querySelector('[data-prev]')?.addEventListener('click', () => ir(i - 1, true));
    puntos.forEach((p) => p.addEventListener('click', () => ir(parseInt(p.dataset.ir, 10), true)));
    // Botón de pausa: si el carrusel se mueve solo, tiene que poder pararse (también en móvil)
    const pausa = root.querySelector('[data-pausa]');
    if (pausa && dur && !reduce) {
      pausa.hidden = false;
      pausa.addEventListener('click', () => {
        parado = !parado;
        pausa.setAttribute('aria-pressed', parado ? 'true' : 'false');
        if (parado) clearTimeout(timer); else programar();
      });
    }
    root.addEventListener('mouseenter', () => { quieto = true; clearTimeout(timer); });
    root.addEventListener('mouseleave', () => { quieto = false; programar(); });
    root.addEventListener('focusin', () => { quieto = true; clearTimeout(timer); });
    // El buscador está en la cabecera, fuera del carrusel: mientras se escribe ahí, el carrusel se para del todo.
    document.addEventListener('focusin', (e) => { if (e.target.matches?.('[data-buscador] input')) { quieto = true; clearTimeout(timer); root.classList.add('hslider--escribiendo'); } });
    document.addEventListener('focusout', (e) => { if (e.target.matches?.('[data-buscador] input')) { quieto = false; root.classList.remove('hslider--escribiendo'); programar(); } });
    // iOS puede esconder el teclado sin quitar el foco al campo: un toque fuera del buscador también levanta la pausa.
    document.addEventListener('pointerdown', (e) => { if (root.classList.contains('hslider--escribiendo') && !e.target.closest('[data-buscador]')) { quieto = false; root.classList.remove('hslider--escribiendo'); programar(); } }, { passive: true });
    root.addEventListener('focusout', (e) => { if (!root.contains(e.relatedTarget)) { quieto = false; programar(); } });
    root.addEventListener('keydown', (e) => { if (e.key === 'ArrowRight') { e.preventDefault(); ir(i + 1); } if (e.key === 'ArrowLeft') { e.preventDefault(); ir(i - 1); } });
    let x0 = null;
    root.addEventListener('pointerdown', (e) => { if (e.pointerType !== 'mouse') x0 = e.clientX; }, { passive: true });
    root.addEventListener('pointerup', (e) => { if (x0 === null) return; const dx = e.clientX - x0; x0 = null; if (Math.abs(dx) > 40) ir(dx < 0 ? i + 1 : i - 1); }, { passive: true });
    document.addEventListener('visibilitychange', programar);
    programar();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  // «Añadir» de las recomendaciones de la cesta (el botón lo pinta product-recommendations; aquí el JS porque esa sección no está en esta página).
  document.addEventListener('click', async (e) => {
    const b = e.target.closest('[data-reco-add]');
    if (!b) return;
    e.preventDefault();
    b.disabled = true;
    try {
      const r = await fetch(window.Shopify && Shopify.routes ? Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(b.dataset.recoAdd), quantity: 1 }] })
      });
      if (r.ok) { location.reload(); return; }
    } catch (err) {}
    b.disabled = false;
  });

  document.querySelectorAll('[data-carro-mas] [data-reco]').forEach(async (el) => {
    try {
      const r = await fetch(el.dataset.url);
      if (!r.ok) return;
      const doc = new DOMParser().parseFromString(await r.text(), 'text/html');
      const n = doc.querySelector('[data-reco]');
      if (n && n.querySelector('.card')) { el.innerHTML = n.innerHTML; el.closest('[data-carro-mas]').classList.add('tiene'); }
    } catch (e) {}
  });

  document.documentElement.classList.add('js');
  document.querySelectorAll('[data-carro]').forEach((form) => {
    let t;
    form.querySelectorAll('input[name="updates[]"]').forEach((i) => i.addEventListener('change', () => { clearTimeout(t); t = setTimeout(() => form.requestSubmit(form.querySelector('[data-actualizar]')), 250); }));
    form.querySelectorAll('[data-cantidad]').forEach((c) => {
      const i = c.querySelector('input'), menos = c.querySelector('[data-menos]'), mas = c.querySelector('[data-mas]');
      const pon = (d) => { i.value = Math.max(+i.min || 0, (+i.value || 0) + d); i.dispatchEvent(new Event('change', { bubbles: true })); };
      menos.addEventListener('click', () => pon(-1)); mas.addEventListener('click', () => pon(1));
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  // Descripción larga: se recorta a unas líneas con «Leer más».
  document.querySelectorAll('[data-clamp]').forEach((d) => {
    const btn = d.parentElement.querySelector('[data-clamp-toggle]');
    if (!btn) return;
    d.classList.add('is-clamped');
    if (d.scrollHeight <= d.clientHeight + 8) { d.classList.remove('is-clamped'); return; }
    btn.hidden = false;
    btn.dataset.mas = btn.textContent;
    btn.addEventListener('click', () => {
      const abierto = d.classList.toggle('is-clamped') === false;
      btn.setAttribute('aria-expanded', abierto);
      btn.textContent = abierto ? 'Leer menos' : btn.dataset.mas;
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  // Vistos recientemente: se guarda este producto en localStorage (máximo 12, el último primero)
  (() => {
    const d = document.querySelector('[data-producto-visto]'); if (!d) return;
    try {
      const yo = { h: d.dataset.handle, u: d.dataset.url, t: d.dataset.title, i: d.dataset.img, p: d.dataset.price, m: d.dataset.vendor };
      const lista = JSON.parse(localStorage.getItem('ho_vistos') || '[]').filter((p) => p && p.h !== yo.h);
      lista.unshift(yo); localStorage.setItem('ho_vistos', JSON.stringify(lista.slice(0, 12)));
    } catch (e) {}
  })();
  // Cantidad: − y + respetan min/max del campo y avisan al formulario
  document.querySelectorAll('[data-cantidad]').forEach((c) => {
    const i = c.querySelector('input'), menos = c.querySelector('[data-menos]'), mas = c.querySelector('[data-mas]');
    const lim = () => { const v = +i.value || 1, min = +i.min || 1, max = i.max ? +i.max : Infinity; menos.disabled = v <= min; mas.disabled = v >= max; };
    const pon = (d) => { const min = +i.min || 1, max = i.max ? +i.max : Infinity; i.value = Math.min(max, Math.max(min, (+i.value || 1) + d)); i.dispatchEvent(new Event('change', { bubbles: true })); lim(); };
    menos.addEventListener('click', () => pon(-1)); mas.addEventListener('click', () => pon(1)); i.addEventListener('input', lim); lim();
  });
  document.querySelectorAll('[data-gallery]').forEach((g) => {
    const main = g.querySelector('#gallery-main');
    if (!main) return;
    const thumbs = [...g.querySelectorAll('.gallery__thumb')];
    // Lista de fotos a tamaño completo: las miniaturas, o solo la principal si no hay más
    const fotos = thumbs.length ? thumbs.map((b) => ({ full: b.dataset.full, alt: b.dataset.alt || '' })) : [{ full: main.dataset.full, alt: main.alt }];
    let actual = Math.max(0, thumbs.findIndex((b) => b.classList.contains('is-active')));
    thumbs.forEach((b, i) => {
      b.addEventListener('click', () => {
        main.src = b.dataset.src;
        main.srcset = b.dataset.srcset;
        main.alt = b.dataset.alt || '';
        thumbs.forEach((x) => x.classList.remove('is-active'));
        b.classList.add('is-active');
        actual = i;
      });
    });
    // Visor: la foto principal o la lupa lo abren; flechas y teclado pasan de foto; Escape o el fondo cierran
    const visor = g.querySelector('[data-visor]');
    if (!visor || typeof visor.showModal !== 'function') return;
    const img = visor.querySelector('.visor__img'), n = visor.querySelector('[data-visor-n]');
    const pinta = () => { const f = fotos[actual]; img.src = f.full; img.alt = f.alt; if (n) n.textContent = fotos.length > 1 ? (actual + 1) + ' / ' + fotos.length : ''; };
    const abrir = () => { pinta(); visor.showModal(); };
    const mover = (d) => { actual = (actual + d + fotos.length) % fotos.length; pinta(); thumbs[actual]?.click(); };
    main.addEventListener('click', abrir);
    g.querySelector('[data-ampliar]')?.addEventListener('click', abrir);
    visor.querySelector('[data-visor-cerrar]').addEventListener('click', () => visor.close());
    visor.querySelector('[data-visor-ant]')?.addEventListener('click', () => mover(-1));
    visor.querySelector('[data-visor-sig]')?.addEventListener('click', () => mover(1));
    visor.addEventListener('click', (e) => { if (e.target === visor) visor.close(); });
    visor.addEventListener('keydown', (e) => { if (e.key === 'ArrowRight') mover(1); if (e.key === 'ArrowLeft') mover(-1); });
  });
  // Cifras destacadas: cuentan de 0 al valor al entrar en pantalla (el HTML ya trae el valor final)
  (() => {
    const nums = document.querySelectorAll('[data-cifras] [data-cuenta]');
    if (!nums.length || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const lang = document.documentElement.lang || 'es';
    const fmt = (v, d) => v.toLocaleString(lang, { minimumFractionDigits: d, maximumFractionDigits: d });
    const anima = (el) => {
      const fin = parseFloat(el.dataset.cuenta); if (isNaN(fin)) return;
      const dec = (el.dataset.cuenta.split('.')[1] || '').length;
      const t0 = performance.now(), dur = 1300;
      const paso = (t) => { const k = Math.min(1, (t - t0) / dur); const e = 1 - Math.pow(1 - k, 3); el.textContent = fmt(fin * e, dec); if (k < 1) requestAnimationFrame(paso); };
      el.textContent = fmt(0, dec); requestAnimationFrame(paso);
    };
    const io = new IntersectionObserver((es) => es.forEach((e) => { if (e.isIntersecting) { anima(e.target); io.unobserve(e.target); } }), { threshold: 0.4 });
    nums.forEach((n) => io.observe(n));
  })();
  // «Avísame cuando vuelva»: alta por fetch en el servicio configurado en los ajustes del tema
  document.querySelectorAll('[data-avisame]').forEach((caja) => {
    const form = caja.querySelector('[data-avisame-form]'); const res = caja.querySelector('[data-avisame-resultado]');
    const btn = caja.querySelector('[data-avisame-btn]'); if (!form) return;
    const pinta = (texto, ok) => { res.hidden = false; res.textContent = texto; res.classList.toggle('is-error', !ok); if (ok) form.hidden = true; };
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const email = (form.email.value || '').trim();
      if (!email || email.indexOf('@') < 1) { pinta(caja.dataset.error, false); form.email.focus(); return; }
      btn.disabled = true;
      try {
        const r = await fetch(caja.dataset.endpoint, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({
          shop: caja.dataset.shop, product_id: Number(caja.dataset.productId), variant_id: Number(caja.dataset.variantId), handle: caja.dataset.handle,
          title: caja.dataset.title, variant_title: caja.dataset.variantTitle || null, email, lang: caja.dataset.lang, web: form.web.value || '' }) });
        const j = await r.json().catch(() => ({}));
        if (r.ok && j.ok) pinta(j.ya ? caja.dataset.repetido : caja.dataset.exito, true);
        else { pinta(j.mensaje || caja.dataset.error, false); btn.disabled = false; }
      } catch (err) { pinta(caja.dataset.error, false); btn.disabled = false; }
    });
  });
  // Descripción larga: se pliega por sus propios titulares. El texto NO se toca ni se mueve del
  // HTML —los buscadores y los asistentes lo siguen leyendo entero—, solo se esconde a la vista.
  // Cinco pantallas de prosa seguida no las lee nadie; plegadas, se elige qué leer.
  (() => {
    const cuerpo = document.querySelector('[data-acordeon] .rte');
    if (!cuerpo) return;
    const hijos = [...cuerpo.children];
    const esTitular = (e) => /^H[23]$/.test(e.tagName);
    if (hijos.filter(esTitular).length < 3) return;   // con menos de tres, no compensa
    const grupos = []; let actual = null;
    for (const e of hijos) {
      if (esTitular(e)) { actual = { titulo: e, cuerpo: [] }; grupos.push(actual); }
      else if (actual) actual.cuerpo.push(e);
      else { actual = { titulo: null, cuerpo: [e] }; grupos.push(actual); }
    }
    const frag = document.createDocumentFragment();
    grupos.forEach((g, i) => {
      if (!g.titulo) { g.cuerpo.forEach((e) => frag.appendChild(e)); return; }
      const d = document.createElement('details');
      d.className = 'pdp-plegable';
      if (i <= 1) d.open = true;
      const sum = document.createElement('summary');
      sum.className = 'pdp-plegable__t';
      sum.innerHTML = g.titulo.innerHTML;
      d.appendChild(sum);
      const caja = document.createElement('div');
      caja.className = 'pdp-plegable__c';
      g.cuerpo.forEach((e) => caja.appendChild(e));
      d.appendChild(caja);
      frag.appendChild(d);
    });
    cuerpo.textContent = '';
    cuerpo.appendChild(frag);
  })();
  // La barra aparece cuando el botón de comprar de verdad sale de pantalla por arriba, y se
  // esconde en cuanto vuelve. Sin JS no se ve, y no pasa nada: el formulario de arriba sigue ahí.
  (() => {
    const barra = document.querySelector('[data-barra]');
    const form = document.querySelector('form[action*="/cart/add"]');
    const btn = form && form.querySelector('.pdp-form__submit');
    if (!barra || !form || !btn) return;
    barra.hidden = false;
    barra.inert = true;   // escondida bajo la pantalla: que el tabulador no caiga en un botón que no se ve
    // En la vista previa, Shopify pone su propia barra fija abajo y tapaba la nuestra. Se mide
    // y nos apartamos por encima. En la web publicada no existe, así que no cambia nada.
    const apartar = () => {
      const pb = document.querySelector('#PBarNextFrame, [id^="PBar"]');
      const alto = pb ? Math.round(pb.getBoundingClientRect().height) : 0;
      barra.style.bottom = alto > 0 && alto < 200 ? alto + 'px' : '';
      // La burbuja del chat vive fija abajo a la derecha, justo donde cae el botón. Se mide de
      // verdad (está en un shadow DOM) y se le deja su hueco, en vez de acertar con un número.
      let hueco = 0;
      for (const sel of ['shopify-chat', '[id*="ShopifyChat"]', '[class*="chat-button"]']) {
        const w = document.querySelector(sel);
        if (!w) continue;
        const dentro = w.shadowRoot || w;
        for (const e of dentro.querySelectorAll('button, a, div')) {
          const b = e.getBoundingClientRect();
          if (b.width < 24 || b.height < 24 || b.width > 320) continue;
          if (innerHeight - b.bottom > 260) continue;          // solo lo que está abajo
          hueco = Math.max(hueco, Math.round(b.width + (innerWidth - b.right)));
        }
      }
      barra.style.setProperty('--barra-hueco', hueco ? hueco + 12 + 'px' : '0px');
    };
    apartar();
    window.addEventListener('resize', apartar);
    setTimeout(apartar, 1500);
    new IntersectionObserver((es) => {
      // 02/10/2026: en el móvil el botón cae bajo la foto (por debajo de la primera pantalla): la barra sale
      // también ANTES de llegar a él, para poder comprar sin bajar. En escritorio, solo cuando ya ha quedado atrás.
      for (const e of es) barra.inert = !barra.classList.toggle('is-visible', !e.isIntersecting && (e.boundingClientRect.top < 0 || innerWidth < 900));
    }, { rootMargin: '0px 0px -20% 0px' }).observe(btn);
    barra.querySelector('[data-barra-add]')?.addEventListener('click', () => {
      if (typeof form.requestSubmit === 'function') form.requestSubmit(btn); else btn.click();
    });
  })();
  document.querySelectorAll('[data-variant-select]').forEach((s) => {
    s.addEventListener('change', () => {
      const url = new URL(window.location.href);
      url.searchParams.set('variant', s.value);
      window.location.assign(url.toString());
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-reco]').forEach(async (el) => {
    try {
      const r = await fetch(el.dataset.url);
      if (!r.ok) return;
      const html = await r.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const n = doc.querySelector('[data-reco]');
      if (n && n.innerHTML.trim()) el.innerHTML = n.innerHTML;
    } catch (e) {}
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rail"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-rail]').forEach((rail) => {
    const lista = rail.querySelector('[data-rail-lista]');
    const prev = rail.querySelector('[data-rail-prev]');
    const next = rail.querySelector('[data-rail-next]');
    if (!lista || !prev || !next) return;
    const paso = () => { const li = lista.querySelector('li'); return li ? li.getBoundingClientRect().width + 20 : 320; };
    const estado = () => {
      prev.disabled = lista.scrollLeft <= 4;
      next.disabled = lista.scrollLeft + lista.clientWidth >= lista.scrollWidth - 4;
    };
    prev.addEventListener('click', () => lista.scrollBy({ left: -paso() * 2, behavior: 'smooth' }));
    next.addEventListener('click', () => lista.scrollBy({ left: paso() * 2, behavior: 'smooth' }));
    lista.addEventListener('scroll', estado, { passive: true });
    window.addEventListener('resize', estado);
    estado();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-slider]').forEach((s) => {
    const pista = s.querySelector('[data-pista]'); const slides = [...pista.children]; if (slides.length < 2) return;
    const puntos = [...s.querySelectorAll('[data-ir]')];
    let i = 0, timer;
    const ir = (n) => { i = (n + slides.length) % slides.length; pista.scrollTo({ left: slides[i].offsetLeft, behavior: 'smooth' }); };
    const marcar = () => { puntos.forEach((p, k) => k === i ? p.setAttribute('aria-current', 'true') : p.removeAttribute('aria-current')); };
    s.querySelector('[data-prev]')?.addEventListener('click', () => { ir(i - 1); parar(); });
    s.querySelector('[data-next]')?.addEventListener('click', () => { ir(i + 1); parar(); });
    puntos.forEach((p) => p.addEventListener('click', () => { ir(+p.dataset.ir); parar(); }));
    pista.addEventListener('scroll', () => { clearTimeout(pista._t); pista._t = setTimeout(() => { i = Math.round(pista.scrollLeft / pista.clientWidth); marcar(); }, 80); }, { passive: true });
    const ms = +s.dataset.autoplay || 0;
    const reducido = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const arrancar = () => { if (ms >= 2000 && !reducido) timer = setInterval(() => ir(i + 1), ms); };
    const parar = () => { clearInterval(timer); timer = null; };
    s.addEventListener('mouseenter', parar); s.addEventListener('mouseleave', () => { if (!timer) arrancar(); });
    s.addEventListener('focusin', parar); s.addEventListener('touchstart', parar, { passive: true });
    document.addEventListener('visibilitychange', () => document.hidden ? parar() : (timer || arrancar()));
    arrancar();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vistos-recientemente"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-vistos]').forEach((sec) => {
    let lista = [];
    try { lista = JSON.parse(localStorage.getItem('ho_vistos') || '[]'); } catch (e) { lista = []; }
    const actual = sec.dataset.actual;
    lista = lista.filter((p) => p && p.h && p.h !== actual).slice(0, +sec.dataset.max || 6);
    if (!lista.length) return;
    const esc = (s) => String(s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
    sec.querySelector('[data-vistos-lista]').innerHTML = lista.map((p) => `<li><a class="visto" href="${esc(p.u)}"><div class="visto__img">${p.i ? `<img src="${esc(p.i)}" alt="" loading="lazy" width="400" height="400">` : ''}</div>${p.m ? `<p class="visto__marca">${esc(p.m)}</p>` : ''}<p class="visto__t">${esc(p.t)}</p><p class="visto__p">${esc(p.p)}</p></a></li>`).join('');
    sec.hidden = false;
  });

  } catch(e) { console.error(e); }
})();
})();
